import { sortByTimestamp } from '@iotv/datamodel-core';
export const metricItemsToVOBs = ({ psuedoParentVob, pseudoTypeId, stateSnapshots }) => stateSnapshots
    .map((stateSnapshot, i) => {
    const { state: { ...atts }, timestamp, } = stateSnapshot;
    const id = `${psuedoParentVob?.id ?? 'unknownId'}_${i}_${timestamp}`;
    const pk = psuedoParentVob?.sk ?? 'unknownParentSk';
    const sk = `${psuedoParentVob?.type}:${id}`;
    const type = pseudoTypeId;
    const intlnz = new Intl.DateTimeFormat('en-NZ', {
        year: 'numeric',
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'NZ',
        hour: 'numeric',
        minute: 'numeric',
    });
    const localTimeStr = timestamp ? intlnz.format(new Date(timestamp)) : 'unknown';
    return {
        type,
        sk,
        pk,
        id,
        ...atts,
        timestamp,
        localTimeStr,
    };
})
    .sort(sortByTimestamp);
